import { render, staticRenderFns } from "./dui-label-group.vue?vue&type=template&id=f030a66c&scoped=true&"
import script from "./dui-label-group.vue?vue&type=script&lang=js&"
export * from "./dui-label-group.vue?vue&type=script&lang=js&"
import style0 from "./dui-label-group.vue?vue&type=style&index=0&id=f030a66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f030a66c",
  null
  
)

export default component.exports